import React from 'react';

const Footer = (props) => {
    return (
        <footer className={`${props.margin} relative top-[50rem] h-[300px] w-full bg-gradient-to-r from-[#392758] via-[#a33076] to-[#e64662]`}>
            <div className='flex flex-col scale-75 md:scale-100 gap-4 text-2xl items-center justify-center h-[300px] w-full text-white font-sen tracking-widest'>
                <p><a href='mailto:jakub.bbednarek32@gmail.com'>jakub.bbednarek32@gmail.com</a></p>
                <p>Jakub Bednarek</p>
            </div>
        </footer>
    );
}

export default Footer;
